import React, { MutableRefObject, useRef, useState } from 'react';

import { IPpdPricesDto } from '@r1-frontend/api-domru/ppd-service/dto/IPpdPricesDto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import type { TDispatch } from '~/src/features/center/BlockInfo';
import { COUNT_SLOTS } from '~/src/features/center/constants/ordinary';
import Slot from '~/src/features/center/Slot';
import type { IData } from '~/src/features/center/utils';
import { useClickOutside } from '~/src/helpers/hooks/useClickOutside';

import * as ST from './styled';

export type TRefObject = MutableRefObject<React.RefObject<HTMLDivElement>[]>;
export type TRef = React.RefObject<HTMLDivElement>[];

interface IProps {
    data: IData[],
    slotRefs: TRefObject,
    city: ICurrentCity,
    dataPrices: IPpdPricesDto[],
}

interface IThis {
    refs: TRefObject,
    setStatus: TDispatch,
}

const InfoBlocks: React.FC<IProps> = ({ data, slotRefs, city, dataPrices }) => {
    const formArray: TRef = [...Array(COUNT_SLOTS)].map(() => React.createRef());
    const formProblemRefs = useRef(formArray);
    const blockPriceRefs = useRef(formArray);
    const [isHiddenForm, setHideStatusForm] = useState(true);
    const [isHiddenPriceBlock, setHideStatusPriceBlock] = useState(true);

    function hideFormHandler(this: IThis, ev: MouseEvent) {
        const formProblemRefsFiltered = this.refs.current.filter(elem => elem.current !== null);
        const [formActiveRef] = formProblemRefsFiltered;
        if (ev.target instanceof Node && !formActiveRef?.current?.contains(ev.target)) {
            this.setStatus(true);
        }
    }

    useClickOutside(isHiddenPriceBlock, hideFormHandler.bind({ refs: blockPriceRefs, setStatus: setHideStatusPriceBlock }));
    useClickOutside(isHiddenForm, hideFormHandler.bind({ refs: formProblemRefs, setStatus: setHideStatusForm }));

    return (
        <ST.GridContainer>
            <ST.Wrapper>
                {data.map((elem) =>
                    <Slot
                        key={elem.index}
                        slotRefs={slotRefs}
                        blockPriceRefs={blockPriceRefs}
                        city={city}
                        formProblemRefs={formProblemRefs}
                        isHiddenForm={isHiddenForm}
                        isHiddenPriceBlock={isHiddenPriceBlock}
                        setHideStatusForm={setHideStatusForm}
                        setHideStatusPriceBlock={setHideStatusPriceBlock}
                        data={elem}
                        dataPrices={dataPrices}
                    />)}
            </ST.Wrapper>
        </ST.GridContainer>
    );
};

export default InfoBlocks;
